/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Not_Applies_ToInputs */

const es_privacy_policy_scope_not_applies_to = /** @type {(inputs: Privacy_Policy_Scope_Not_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se aplica a:`)
};

const en_privacy_policy_scope_not_applies_to = /** @type {(inputs: Privacy_Policy_Scope_Not_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It does not apply to:`)
};

/**
* | output |
* | --- |
* | "It does not apply to:" |
*
* @param {Privacy_Policy_Scope_Not_Applies_ToInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_not_applies_to = /** @type {((inputs?: Privacy_Policy_Scope_Not_Applies_ToInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Not_Applies_ToInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_not_applies_to(inputs)
	return en_privacy_policy_scope_not_applies_to(inputs)
});
export { privacy_policy_scope_not_applies_to as "privacy_policy.scope.not_applies_to" }